<template>
  <div id="newReturn">
    <table-title>归还办理信息</table-title>
    <Form ref="formValidates" :model="formValidate" :label-width="135" inline :rules="ruleValidate">
      <FormItem label="租借人：" prop="leaseeId">
        <leasee-select roleType="LEASEE" @onChange="onChangeLeasee" v-model="formValidate.leaseeId" />
      </FormItem>
      <FormItem label="标的物小类：" prop="targetType">
        <Select v-model="formValidate.targetType" style="width:200px" filterable clearable label-in-value @on-change="onTargetType">
          <Option v-for="item in targetList" :value="item.code" :key="item.id">{{ item.text }}</Option>
        </Select>
      </FormItem>
      <br />
      <FormItem label="回收方式：" prop="recycleMethod">
        <dict-select namespace="ENUM_MID-OPERATE-LEASE" id="recycleAppointment.RecycleMethod" @on-change="onRecycleMethod" v-model="formValidate.recycleMethod" />
      </FormItem>
      <FormItem label="责任分区" v-if="formValidate.leaseeId" key="groupFlag">
        <bizSelect key="groupFlag" v-model="formValidate.groupFlag" url="http://CORE-MEMBER/messageService/respZoneService/queryRespZoneByMemberId" :params="{memberId:formValidate.leaseeId}" codeField="respZoneId" style="width:200px" />
      </FormItem>
      <br>
      <FormItem label="预约归还总数：" prop="totalAmount">
        <InputNumber style="width:200px" :min="1" v-model="formValidate.totalAmount" active-change placeholder="请输入" />
      </FormItem>
      <Button type="success" :disabled="!formValidate.totalAmount" @click="onAuto">自动匹配</Button>
      <FormItem v-if="formValidate.recycleMethod==='DEPOSIT'" label="可交付日期" prop="expectedBillingUntil">
        <DatePicker type="date" placeholder="请选择可交付日期" :editable="false" @on-change="expectDate" v-model="formValidate.expectedBillingUntil" style="width:200px"></DatePicker>
      </FormItem>
      <br />
      <template v-if="formValidate.recycleMethod === 'DEPOSIT'">
        <FormItem label="仓库：" prop="radiaStorage">
          <RadioGroup v-model="formValidate.radiaStorage" @on-change="radiaOnChange">
            <Radio label="现有仓库"></Radio>
            <Radio label="新增仓库"></Radio>
          </RadioGroup>
        </FormItem>
        <br />
        <FormItem label="仓库名称" v-if="formValidate.radiaStorage === '现有仓库'" prop="name">
          <Input style="width:200px" disabled v-model="formValidate.name" />
        </FormItem>
        <Button type="success" v-if="formValidate.radiaStorage === '现有仓库'" :disabled="formValidate.leaseeId?false:true" @click="selectStorage">选择仓库</Button>
        <br />
        <template v-if="formValidate.radiaStorage === '新增仓库'">
          <FormItem label="仓库所在区域" prop="storageArea">
            <addr-cascader :unknownAddress="false" @on-select-change="onSelect" v-model="formValidate.storageArea" />
          </FormItem>
          <FormItem label="仓库地址" prop="storageAddress">
            <Input style="width:200px" v-model="formValidate.storageAddress" type="textarea" maxlength="100" show-word-limit placeholder="请输入" />
          </FormItem>
          <Button type="success" @click="onRecognition" :disabled="formValidate.storageAddress && formValidate.leaseeId?false:true" size="small">识别</Button><br>
          <FormItem label="仓库名称" prop="storageName">
            <Input style="width:200px" v-model="formValidate.storageName" placeholder="请输入" />
          </FormItem>
        </template>
      </template>

      <FormItem label="联系人" prop="linkmanId">
        <Input style="width:200px" disabled v-model="formValidate.linkmanId" />
      </FormItem>
      <Button type="success" :disabled="formValidate.leaseeId?false:true" @click="selectContact">选择联系人</Button>
      <br />
      <FormItem label="寄存仓库" key="selfDeliveryDepositedStorageId" v-if="formValidate.recycleMethod ==='SELF_DELIVERY' && depositList.length">
        <Select v-model="formValidate.selfDeliveryDepositedStorageId" style="width:200px" filterable clearable>
          <Option v-for="item in depositList" :value="item.storageId" :key="item.storageId">{{item.$storageId +'---数量  '+item.depositAmt }}</Option>
        </Select>
      </FormItem>
      <FormItem label="寄存数量" v-if="formValidate.selfDeliveryDepositedStorageId && formValidate.recycleMethod ==='SELF_DELIVERY' && depositList.length">
        <InputNumber style="width:200px" :min="1" :max="maxDepositAmt" @on-change="onAuto" v-model="formValidate.selfDeliveryDepositedAmount" clearable :placeholder="'最大可输入寄存数量 '+maxDepositAmt" />
      </FormItem>
      <br>
      <FormItem label="备注">
        <Input v-model="formValidate.recycleAppointmentComment" type="textarea" style="width:490px" />
      </FormItem><br>
      <FormItem label="上传附件">
        <upload ref="upFile" :height="70" :width="490" @success="uploadSuccess" @delete="onDelete"></upload>
      </FormItem>
    </Form>
    <table-title>预期停租结果
      <plt-biz-select v-model="formValidate.fromMember" :transfer="false" url="http://MID-OPERATE-LEASE/messageService/deliverService/queryDeliverOutLeaseeList" :params="{memberId:formValidate.leaseeId}" placeholder="合约上游(非必选)" style="width: 200px" />
      <Select v-model="formValidate.leaseeFrame" style="width:250px" filterable clearable label-in-value placeholder="可选择框架协议后,刷新筛选">
        <Option v-for="item in frameList" :value="item.value" :key="item.value">{{ item.label}}</Option>
      </Select>
      <Button type="success" style="margin-left:10px" @click="onRefresh" :disabled="formValidate.targetType && formValidate.leaseeId?false:true" size="small">刷新</Button>
    </table-title>
    <data-grid v-if="tableShows" :columns="colsTwo" :queryParams="{}" :pagination="false" :autoLoad="false" :pageSize="50" subListName :dataList="dataListTwo">
      <template #default="{columns, data}">
        <Table border :columns="columns" :data="data">
          <template slot-scope="{row}" slot="leaseeFrame">
            <a href="javascript:;" class="hoverCollection" style="color: #2d8cf0" @click="goDetail(row.leaseeFrame)">{{row.leaseeFrame}}</a>
          </template>
          <template slot-scope="{row,index}" slot="remainAmount">
            <p>
              <span>最大可停租数量：</span>
              <span style="color:red">{{dataMax[index].remainAmount}}</span>
            </p>
            <InputNumber :min="1" :max="dataMax[index].remainAmount" :value="row.totalAmount" style="width:130px" @on-change="onChangeNum($event,index)"></InputNumber>
          </template>
        </Table>
      </template>
    </data-grid>
    <leaseholder-detail ref="holderDetailRef"></leaseholder-detail>

    <div style="text-align:center">
      <Button @click="reset">重置</Button>
      <Button type="primary" style="margin-left:10px" @click="submint">提交</Button>
    </div>
    <storage-select ref="storageSelect" @on-select-storage="onSelectStorage" />
    <contact-select ref="contactSelect" @on-select-contact="onSelectContact" />
  </div>
</template>

<script>
import tableTitle from '@/components/tableTitle/tableTitle.vue'
import dictSelect from '@/components/select/dict-select.vue'
import leaseeSelect from '@/components/select/payee-select.vue'
import addrCascader from '@/components/select/addr-cascader.vue'
import dataGrid from '@/components/datagrid.vue'
import upload from '_c/upload/upload.vue'
import bizSelect from '_c/select/biz-select'

import storageSelect from '@/components/select/storage-select.vue'
import contactSelect from '@/components/select/contact-select.vue'
import leaseholderDetail from '@/views/user-center/component/leaseholderDetail.vue'
export default {
  name: 'newReturn',
  components: {
    tableTitle,
    dictSelect,
    leaseeSelect,
    storageSelect,
    addrCascader,
    contactSelect,
    dataGrid,
    upload,
    bizSelect,
    leaseholderDetail
  },
  data() {
    return {
      targetList: [],//标的物小类数据
      dataMax: [],
      dataListTwo: [],//预期停租结果
      tableShows: true,
      contracts: [],
      colsTwo: [
        { type: 'selection', width: 50 },
        { title: '合约id', key: "id" },
        { title: '租借人', key: "leaseeId", dict: ['bizObjects', 'member', true] },
        { title: '合伙人', key: "leaserId", dict: ['bizObjects', 'member', true] },
        { title: '框架协议', slot: "leaseeFrame" },
        { title: '计费模式', key: "modelId", dict: ['default', 'billingModel', true] },
        { title: '起租数量', key: "amount" },
        { title: '可停租数量', slot: "remainAmount", width: 150 },
        { title: '租期', key: "rentTerm" },
        { title: '开始计租日', key: "billingStartDate" },
        { title: '租借人最小停租时间', key: "leaseeMinBillingStopDate" },
        { title: '合约类型', key: "rentWay", dict: ['ENUM_CORE-CONTRACT', 'contractEntity.RentWay'] },
        { title: '上游', key: "fromMemberId", dict: ['bizObjects', 'member', true] },
        { title: '备注', key: "remark" },
      ],
      attachmentFileIds: [],//附件
      formValidate: {
        recycleMethod: "",
        leaseeId: "",
        targetType: "",
        expectedBillingUntil: "",
        storageId: "",
        storageName: "",
        storageAddress: "",
        storageArea: "",
        totalAmount: '',
        contactId: "",
        name: '',
        linkmanId: '',
        radiaStorage: '现有仓库',
        recycleAppointmentComment: "",//备注
        groupFlag: "",//参与人分组
        selfDeliveryDepositedAmount: 0,//寄存数量
        selfDeliveryDepositedStorageId: "",//寄存仓库
        fromMember : ""
      },
      storageVal: {
        storageName: '',
        storageArea: '',
        storageAddress: ""

      },
      ruleValidate: {
        leaseeId: [{ required: true, message: "租借人不能为空！" }],
        targetType: [{ required: true, message: "请选择标的物小类", trigger: "change" }],
        totalAmount: [{ required: true, message: '预约归还总数' }],
        recycleMethod: [{ required: true, message: "请选择回收方式", trigger: "change" }],
        name: [{ required: true, message: "仓库名称不能为空！" }],
        expectedBillingUntil: [{ required: true, message: "请选择可交付日期", trigger: 'change' }],
        storageName: [{ required: true, message: "仓库名称不能为空！" }],
        storageAddress: [{ required: true, message: "仓库地址不能为空！" }],
        storageArea: [{ required: true, message: "仓库所在区域不能为空", trigger: "change" }],
        linkmanId: [{ required: true, message: "联系人不能为空！" }],
        radiaStorage: [{ required: true, message: "请选择仓库类型", trigger: "change" }]
      },
      frameList: [],
      appointedContract: '',//转户界面跳转,指定的合约号
      depositList: [],
      maxDepositAmt: 0
    }
  },
  watch: {
    'formValidate.groupFlag': function (newVal) {
      if (this.formValidate.leaseeId && this.formValidate.targetType)
        this.getStopBilling(this.formValidate.leaseeId, this.formValidate.targetType, newVal);
    },
    "formValidate.totalAmount": function (newVal) {
      if (!newVal) {
        this.dataListTwo.forEach((item, index) => {
          let data = item
          data._checked = false;
          data.totalAmount = "";
          this.$set(this.dataListTwo, index, data);
        })
      }
    },
    "formValidate.selfDeliveryDepositedStorageId": function (newVal) {
      if (newVal) {
        let maxAmount = this.depositList.find(({ storageId }) => storageId === newVal).depositAmt;
        this.formValidate.selfDeliveryDepositedAmount = maxAmount;
        this.maxDepositAmt = maxAmount;
        this.onAuto();
      }
      if (!newVal)
        this.formValidate.selfDeliveryDepositedAmount = "";

    }
  },
  async mounted() {
    let param = this.$route.query;
    if (param.deliverId) {
      this.formValidate.recycleMethod = 'DEPOSIT';
      this.formValidate.recycleAppointmentComment = param.deliverAddress;
      this.formValidate.leaseeId = param.memberId;
      await this.onChangeLeasee(param.memberId);
      this.formValidate.targetType = param.targetType;
      this.formValidate.totalAmount = param.remainAmount;
      this.appointedContract = param.contractId;
      await this.onTargetType({ value: param.targetType });
      setTimeout(() => {
        this.onAuto();
      }, 1000);
    }
  },
  methods: {
    // 查询寄存
    async getDepositList(memberId, targetType) {
      let url = "http://MID-OPERATE-LEASE/messageService/recycleService/queryLeaseDepositsForSelfDelivery";
      this.depositList = await this.invoke(url, { memberId, targetType });
    },
    //   输入租借人和仓库区域 自动生成仓库名
    getStorageName() {
      if (!this.formValidate.leaseeId || !this.formValidate.storageArea) return;
      let url = "http://CORE-STORAGE/messageService/operateService/generateDefaultStorageName";
      this.invoke(url, { areaId: this.formValidate.storageArea, memberId: this.formValidate.leaseeId }).then(res => {
        this.formValidate.storageName = res;
      })
    },
    getFrameList() {
      if (!this.formValidate.leaseeId || !this.formValidate.targetType) {
        this.frameList = [];
      } else {
        let data = {
          url: "CORE-CONTRACT/messageService/queryService/queryLeaseeFrameByLeaseeContracts",
          body: {
            leaseeId: this.formValidate.leaseeId,
            targetType: this.formValidate.targetType
          }
        }
        this.invoke(data).then((res) => {
          this.frameList = res
        })
      }
    },
    goDetail(leaseeFrame) {
      this.$refs['holderDetailRef'].openModal(leaseeFrame)
    },
    // 上传成功
    uploadSuccess(params) {
      this.attachmentFileIds.push(params.body)
    },
    // 附件删除
    onDelete({ id }) {
      this.attachmentFileIds = this.attachmentFileIds.filter(item => item != id);
    },
    // 识别省市区
    onRecognition() {
      let data = {
        url: "CORE-COMMON/messageService/regionService/autoRecognizeRegion",
        body: { address: this.formValidate.storageAddress }
      }
      this.invoke(data).then(res => {
        if (res) {
          this.$Message.success('识别成功')
          this.formValidate.storageArea = res.regionCode;
          this.formValidate.storageAddress = res.address;
        } else {
          this.$Message.error('请输入符合规范详细地址')
        }
      })
    },
    // 刷新合约
    onRefresh() {
      this.getStopBilling(this.formValidate.leaseeId, this.formValidate.targetType, this.formValidate.groupFlag, this.formValidate.leaseeFrame);
    },
    // 标的物小类数据
    async getTargetList() {
      this.targetList = [];
      let data = {
        url: "CORE-CONTRACT/messageService/contractService/queryTargetTypesByLeaseeContracts",
        body: {
          leaseeId: this.formValidate.leaseeId
        }
      }
      this.targetList = await this.invoke(data)
    },
    // 租借人
    onChangeLeasee(params) {
      this.formValidate.storageName = "";
      this.getFrameList();
      this.getStorageName();
      if (params)
        this.getTargetList();
      if (params && this.formValidate.targetType) {
        this.getDepositList(params, this.formValidate.targetType);
        this.getStopBilling(params, this.formValidate.targetType, this.formValidate.groupFlag)
        this.formValidate.linkmanId = "";
        this.formValidate.contactId = "";
        this.formValidate.name = "";
        this.formValidate.storageId = ""
      }
    },
    // 标的物小类
    onTargetType({ value } = { value: '' }) {
      this.formValidate.targetType = value
      if (this.formValidate.leaseeId && value) {

        this.getDepositList(this.formValidate.leaseeId, value);
        this.getStopBilling(this.formValidate.leaseeId, value, this.formValidate.groupFlag)
      }
      this.getFrameList();
    },
    // 回收方式
    onRecycleMethod(params) {
      this.formValidate.recycleMethod = params
      if (params === 'SELF_DELIVERY') {
        this.formValidate.expectedBillingUntil = ''
        this.formValidate.storageId = '';
        this.formValidate.storageName = '';
        this.formValidate.storageAddress = '';
        this.formValidate.storageArea = '';
      } else {
        this.formValidate.radiaStorage = '现有仓库';
         this.formValidate.selfDeliveryDepositedAmount="";
        this.formValidate.selfDeliveryDepositedStorageId="";
      }
    },
    // 预期停租日
    expectDate(params) {
      this.formValidate.expectedBillingUntil = params
    },
    selectContact() {
      this.$refs['contactSelect'].openModal(this.formValidate.leaseeId)
    },
    // 选择联系人回调
    onSelectContact(params) {
      this.formValidate.linkmanId = params.name
      this.formValidate.contactId = params.id
    },
    selectStorage() {
      let type = ''
      if (this.formValidate.recycleMethod === 'SELF_DELIVERY') {
        type = 'INNER'
      } else {
        type = 'OUTER'
      }
      this.$refs['storageSelect'].openStorage(type, this.formValidate.leaseeId, this.formValidate.recycleMethod)
    },
    onSelectStorage(params) {
      this.formValidate.name = params.name
      this.formValidate.storageId = params.id
      this.formValidate.linkmanId = this.$options.filters['queryDict']('bizObjects', 'contact', params.linkmanId);
      this.formValidate.contactId = params.linkmanId;
    },
    // 选择仓库
    radiaOnChange(val) {
      if (val === '新增仓库') {
        this.formValidate.name = '';
        this.formValidate.storageId = '';
      } else {
        this.formValidate.storageName = '';
        this.formValidate.storageAddress = '';
        this.formValidate.storageArea = '';
      }
    },
    // 仓库区域
    onSelect(params) {
      this.formValidate.storageName = "";
      this.formValidate.storageArea = params;
      this.getStorageName();
    },
    // 停租合约列表
    getStopBilling(leaseeId, targetType, groupFlag, leaseeFrame) {
      let contractId = this.appointedContract;
      let data = {
        url: 'MID-OPERATE-LEASE/messageService/recycleService/queryContractListToStopBilling',
        body: { params: { leaseeId, targetType, groupFlag, leaseeFrame, contractId ,fromMember:this.formValidate.fromMember} }
      }
      this.tableShows = false
      this.invoke(data).then(res => {
        this.tableShows = true
        this.dataListTwo = res
        this.dataListTwo.forEach(item => {
          item.totalAmount = "";
          item._disabled = true;
          return item._checked = false
        })
        this.dataMax = JSON.parse(JSON.stringify(res))
      })
    },
    onAuto() {
      if (!this.formValidate.totalAmount) return;

      if (this.formValidate.selfDeliveryDepositedAmount > this.formValidate.totalAmount) return this.$message.warning("寄存数量不能大于归还总数量");

      if (!this.formValidate.totalAmount) return;
      let val = this.formValidate.totalAmount - this.formValidate.selfDeliveryDepositedAmount;

      this.dataListTwo.forEach((item, index) => {
        let data = item
        let quantity = Math.min(data.remainAmount, val);
        data.totalAmount = quantity;
        val -= quantity;
        if (data.totalAmount) {
          data._checked = true;
        } else {
          data._checked = false;
          data.totalAmount = "";
        }
        this.$set(this.dataListTwo, index, data);

      })
    },
    onChangeNum(val, index) {
      let param = this.dataListTwo[index]
      param.totalAmount = val
      param._checked = true
      if (!param.totalAmount) {
        param._checked = false
      }
      this.$set(this.dataListTwo, index, param)
    },
    reset() {
      this.attachmentFileIds = [];
      this.tableShows = false
      this.formValidate.recycleAppointmentComment = "";
      this.$refs.upFile.$refs.uploadFile.clearFiles();
      this.frameList = [];
      this.formValidate.leaseeFrame = '';
      this.formValidate.fromMember = '';
      this.formValidate.totalAmount = "";
      setTimeout(() => {
        this.dataListTwo = []
        this.tableShows = true
      }, 50)
      this.$refs['formValidates'].resetFields();
    },
    async submint() {
      let vaild = await this.$refs['formValidates'].validate()
      if (!vaild) return;

      if (this.formValidate.selfDeliveryDepositedStorageId) {
        if (!this.formValidate.selfDeliveryDepositedAmount) return this.$Message.warning("请输入寄存数量");
      }
      let contracts = this.dataListTwo.filter(({ _checked }) => _checked).map(({ id, totalAmount }) => ({ contractNo: id, totalAmount }))

      let data = {
        url: 'MID-OPERATE-LEASE/messageService/recycleService/newRecycleAppointment',
        body: {
          attachmentFileIds: this.attachmentFileIds,
          recycleAppointment: {
            recycleMethod: this.formValidate.recycleMethod,
            leaseeId: this.formValidate.leaseeId,
            targetType: this.formValidate.targetType,
            expectedBillingUntil: this.formValidate.expectedBillingUntil,
            storageId: this.formValidate.storageId,
            storageName: this.formValidate.storageName,
            storageAddress: this.formValidate.storageAddress,
            storageArea: this.formValidate.storageArea,
            totalAmount: this.formValidate.totalAmount,
            contactId: this.formValidate.contactId,
            stopBillingContracts: contracts,
            recycleAppointmentComment: this.formValidate.recycleAppointmentComment,
            groupFlag: this.formValidate.groupFlag,
            selfDeliveryDepositedAmount: this.formValidate.selfDeliveryDepositedAmount,
            selfDeliveryDepositedStorageId: this.formValidate.selfDeliveryDepositedStorageId,
          }
        }
      }
      this.$Modal.confirm({
        title: '确定要新增归还吗?',
        onOk: () => {
          this.invoke(data).then(res => {
            if (res) {
              this.$Message.success('新增归还成功！')
              if (this.$route.query.deliverId) {//转户接收跳转 则退回刷新
                this.$router.go(-1);
              } else {
                this.reset()
              }
            }
          })

        },
      });
    }
  }

}
</script>

<style lang="scss" scoped>
</style>